import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
export class FileThumb extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
            thumb: undefined,
        };
        this.handleRemoveClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const { file, onRemove } = this.props;
            if (file && onRemove) {
                onRemove(file);
            }
        };
    }
    // eslint-disable-next-line react/no-deprecated
    componentWillReceiveProps(nextProps) {
        if (!nextProps.file) {
            this.setState({ loading: false, thumb: undefined });
            return;
        }
        this.setState({ loading: true }, () => {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({ loading: false, thumb: reader.result });
            };
            if (nextProps.file) {
                reader.readAsDataURL(nextProps.file);
            }
            else {
                this.setState({ loading: false, thumb: undefined });
            }
        });
    }
    render() {
        const { file } = this.props;
        const { loading } = this.state;
        if (!file) {
            return null;
        }
        if (loading) {
            return _jsx("p", { children: "loading..." });
        }
        return (_jsx(Fragment, { children: _jsx("section", { className: "file-upload-details", children: _jsx("div", { className: "file-details", children: _jsxs("p", { children: [this.props.onRemove && (_jsx(Button, { startIcon: _jsx(DeleteIcon, {}), size: "small", onClick: this.handleRemoveClick })), file.name, " ", _jsxs("span", { children: [Math.round(file.size || 0 / 1000), " KB"] })] }) }) }) }));
    }
}
